import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private http: HttpClient) {}

  private apiUrl2 = 'https://devapi.axelone.app/api/';
  // private rolesUrl = 'https://cavenderapi.axelautomotive.com/api/';



  getmethod2(endpoint: string, params: any): Observable<any> {
    return this.http.get(`${this.apiUrl2}${endpoint}`, { params });
  }

  getmethod3(endpoint : string, params: any): Observable<any>{
    return this.http.get(`${this.apiUrl2}${endpoint}`, {params});
  }

  postmethod(endpoint: string, payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl2}${endpoint}`, payload).pipe(
      map(res => res)
    );
  }

  putmethod(endpoint: string, payload: any): Observable<any> {
    return this.http.put(`${this.apiUrl2}${endpoint}`, payload).pipe(
      map(res => res)
    );
  }

  // deletemethod(endpoint: string): Observable<any> {
  //   return this.http.delete(`${this.apiUrl2}${endpoint}`).pipe(
  //     map(res => res)
  //   );
  // }

  // ============================
  // ROLES
  // ============================
  // getRolesList(payload: any): Observable<any> {
  //   return this.http.post(`${this.rolesUrl}users/GetUserRoles`, payload);
  // }

  // getRoleById(roleId: number): Observable<any> {
  //   return this.http.get(`${this.apiUrl2}roles/${roleId}`);
  // }

  // updateRole(roleId: number, payload: any): Observable<any> {
  //   return this.http.put(`${this.apiUrl2}roles/${roleId}`, payload);
  // }



  // ============================
  // WIDGETS CRUD
  // ============================
  // getWidgets(): Observable<any[]> {
  //   return this.http.get<any[]>(`${this.apiUrl2}widgets`);
  // }

  // getWidgetById(widgetId: number): Observable<any> {
  //   return this.http.get(`${this.apiUrl2}widgets/${widgetId}`);
  // }

  // addWidget(payload: any): Observable<any> {
  //   return this.http.post(`${this.apiUrl2}widgets`, payload);
  // }

  // updateWidget(widgetId: number, payload: any): Observable<any> {
  //   return this.http.put(`${this.apiUrl2}widgets/${widgetId}`, payload);
  // }

  // deleteWidget(widgetId: number): Observable<any> {
  //   return this.http.delete(`${this.apiUrl2}widgets/${widgetId}`);
  // }

}
